import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { TENANT_SLUG } from '../lib/tenant';

export interface Tenant {
  id: string;
  slug: string;
  name: string;
  status: string;
}

interface TenantState {
  tenant: Tenant | null;
  slug: string | null;
  loading: boolean;
  notFound: boolean;
}

const TenantCtx = createContext<TenantState>({
  tenant: null,
  slug: null,
  loading: true,
  notFound: false,
});

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<TenantState>({
    tenant: null,
    slug: TENANT_SLUG,
    loading: !!TENANT_SLUG,
    notFound: false,
  });

  useEffect(() => {
    if (!TENANT_SLUG) {
      setState((s) => ({ ...s, loading: false }));
      return;
    }
    (async () => {
      const { data } = await supabase
        .from('tenants')
        .select('id,slug,name,status')
        .eq('slug', TENANT_SLUG)
        .maybeSingle();
      if (!data) {
        setState({ tenant: null, slug: TENANT_SLUG, loading: false, notFound: true });
      } else {
        setState({ tenant: data as Tenant, slug: TENANT_SLUG, loading: false, notFound: false });
      }
    })();
  }, []);

  return <TenantCtx.Provider value={state}>{children}</TenantCtx.Provider>;
};

export const useTenant = () => useContext(TenantCtx);
